import React from "react";
import "../AudioTag/styles.scss";
import defaultAlbumImg from "../../../../../public/images/default-alblum-img.png";
import { useSelector } from "react-redux";
import hv_player_api from "../../../../../api/hv_player_api";
import Actions from "../../Actions";
import { ReactComponent as MenuIcon } from "../../../../../public/shared/menu-icon-default.svg";
import { Dropdown } from "react-bootstrap";
import RemoveIcon from "../../../../../public/shared/x-remove-icon.png";
import { isSelfId } from "../../../../../api/helper";

export default ({ className, medium, mediumSetter, showActions = false, removeMedium = null, user }) => {
  const controls = useSelector((state) => state);
  return (
    <div className={`audio-tag d-flex align-items-center pr-3 ${className}`}>
      <div className="preview-img mr-2">{<img src={medium.preview_image ? medium.preview_image.url : defaultAlbumImg} alt="ALBUM-THUMBNAIL" />}</div>
      <div className="d-flex flex-column w-100">
        <div className="d-flex flex-row justify-content-between ">
          {medium.title && <p className="title m-0">{medium.title}</p>}
          {isSelfId(user && user.id) && (
            <Dropdown>
              <Dropdown.Toggle as={MenuIcon} />
              <Dropdown.Menu>
                <Dropdown.Item className="d-flex" onClick={() => removeMedium(medium.id)}>
                  <img src={RemoveIcon} alt="REMOVE PLAYLIST ITEM" className="mr-3" />
                  Remove
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
        {showActions && <Actions object={medium} setObject={mediumSetter} user={controls.current_user} />}
      </div>
    </div>
  );
};
